import React from 'react';

/**
 * Similar in functionality to React.Component's setState
 * @param {Object} initialState
 */
function useMergeState(initialState = {}) {
  const [state, mergeState] = React.useReducer(
    (state, newState) => ({ ...state, ...newState }),
    initialState
  );
  return [state, mergeState];
}

export { useMergeState };

export default useMergeState;



// WEBPACK FOOTER //
// ./src/common/Hooks/useMergeState.js